import { LoadSegmentsRequest } from '@/models/LoadSegmentsRequest';

import { confugrationApi } from '@/api/configurationApi';
import { segmentsApi } from '@/api/segmentsApi';

export class proofreadingDocumentService {

    async loadConfigurations(documentId: number) {
        return confugrationApi.getProofreadingTranslationConfig(documentId);
    }

    async loadTranslationSegments(request: LoadSegmentsRequest) {
        return segmentsApi.getDocumentSegments(request);
    }
}
